import React from 'react';
import { observer } from 'mobx-react';
import { ContactDepartmentListTemplate } from 'themes/application/contact-department/pages';
import { setCurrentView } from 'core/utils';
import { ContactDepartmentListViewStore } from 'application/contact-department/stores';

@setCurrentView((rootStore) => new ContactDepartmentListViewStore(rootStore), 'contactDepartmentListViewStore')
@observer
class ContactDepartmentList extends React.Component {
    render() {
        return <ContactDepartmentListTemplate {...this.props} />
    }
}

export default ContactDepartmentList;